import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './index.scss';
import { MIN_LEADERS_REQUIRED } from './constants';

const InsufficientSelectionNotice = ({ count = 0 }) => (
    <div className='insufficient-selection'>
        <span className='insufficient-selection__icon'>
            <ExclamationCircleOutlined />
        </span>
        <div className='insufficient-selection__body'>
            <p className='insufficient-selection__title'>
                Select at least {MIN_LEADERS_REQUIRED} leader names to view benchmark analysis results.
            </p>
            <p className='insufficient-selection__subtitle'>
                You currently have <strong>{count}</strong> of {MIN_LEADERS_REQUIRED} selected. Aggregate
                results are shown only for {MIN_LEADERS_REQUIRED} or more leaders, to protect individual
                confidentiality. Use the Survey Name filter above to add more.
            </p>
        </div>
    </div>
);

export default InsufficientSelectionNotice;
